import APIService from "@/services/APIService.js"; 

export default {
  getRcps(includeExpiredRecords) {
    return APIService.apiCall().get(`/Rcp/getRcps/${includeExpiredRecords}`);
  },
  excluir(id) {
    return APIService.apiCall().get(`/Rcp/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/Rcp/executar/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/Rcp/salvar`,JSON.stringify(postData))
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/Rcp/baixarPlanilha/${id}`, { responseType: "blob", ...config });
  }
};